
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import image from '../assets/Logo.jpg';
import { Link } from "react-router-dom";

function About() {
    return (
        <>
        {/* Contact Info - Email (Left) & Phone (Right) */}
        <div className="d-flex flex-wrap justify-content-between align-items-center p-2 px-3 bg-light">
                <div className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faEnvelope} className="me-2 text-orange" />
                    <span className="fw-bold">ultramobiles07@gmail.com</span>
                </div>
                <div className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faPhone} className="me-2 text-orange" />
                    <span className="fw-bold">9994141075</span>
                </div>
            </div>
           {/* Navbar */}
           <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <div className="container d-flex justify-content-between align-items-center">
                    {/* Logo and Institute Name */}
                    <div className="d-flex align-items-center">
                        <Link className="navbar-brand" to="/">
                            <img src={image} className="d-block" style={{ width: "70px" }} alt="Ultramobiles" />
                        </Link>
                        <div className="brand-title ms-2">Ultra Mobiles Training Institute</div>
                    </div>

                    {/* Navbar Toggle Button */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    {/* Navbar Links */}
                    <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
                        <ul className="navbar-nav">
                            <li className="nav-item"><Link className="nav-link" to="/">Home</Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/course">Course</Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/about">About</Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/contact">Contact</Link></li>
                        </ul>
                    </div>
                </div>
            </nav>
            {/* About Section */}
            <div className="container mt-5">
                <h2 className="text-center" style={{ color: "orange" }}>About Us</h2>
                <p className="text-center text-muted">Empowering Students with Technical Skills in Mobile Repairing</p>

                {/* Description */}
                <div className="card shadow-sm p-4 mt-4">
                    <h3 style={{ color: "orange" }}>Our Story</h3>
                    <p style={{ textAlign: "justify" }}>
                        Ultramobiles Training Institute is a leading technical training institute specializing in mobile phone repairing. 
                        Our mission is to provide hands-on learning experiences and professional training to individuals seeking careers in the mobile repairing industry.
                        With years of expertise and a commitment to excellence, we have helped thousands of students build a successful career.
                    </p>
                </div>

                {/* Mission */}
                <div className="card shadow-sm p-4 mt-4">
                    <h3 style={{ color: "orange" }}>Our Mission</h3>
                    <p style={{ textAlign: "justify" }}>
                        Our mission is to equip aspiring technicians with the necessary knowledge and skills to repair and service mobile devices effectively. 
                        We aim to bridge the gap between theoretical learning and real-world application through practical training and industry-relevant curriculum.
                    </p>
                </div>

                {/* Vision */}
                <div className="card shadow-sm p-4 mt-4">
                    <h3 style={{ color: "orange" }}>Our Vision</h3>
                    <p style={{ textAlign: "justify" }}>
                        We envision a future where skilled professionals drive the mobile repair industry forward with innovation and expertise. 
                        By offering top-notch training programs, we strive to create job opportunities, enhance technical proficiency, and contribute to the technological growth of society.
                    </p>
                </div>
            </div>

            {/* Footer */}
            <footer style={{ backgroundColor: "orange", color: "white", textAlign: "center", padding: "15px", marginTop: "20px" }}>
                <p className="mb-0">COPYRIGHT © 2025 Ultramobiles Training Institute. All Rights Reserved.</p>
            </footer>

            <style>
                {`
                    .brand-title {
                        font-weight: bold;
                        font-size: 1.3rem;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    @media (max-width: 768px) {
                        .brand-title {
                            font-size: 1.1rem;
                            text-align: center;
                            padding-top: 5px;
                        }
                    }

                    @media (max-width: 480px) {
                        .brand-title {
                            font-size: 1rem;
                            white-space: normal; /* Allow text to wrap */
                            text-align: left;
                        }
                    }

                    @media (max-width: 320px) {
                        .brand-title {
                            font-size: 0.9rem; /* Reduce text size */
                            white-space: normal;
                            text-align: left;
                        }
                    }

                    .text-orange { color: orange; }
                    .bg-orange { background: orange; }
                `}
            </style>
        </>
    );
}

export default About;
